import { CallServices, CoreServices } from "../../base/service/apiServices";

import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getCoChatChannels = createAsyncThunk("getCoChatChannels", async () => {
  // return CoreServices.get("/get_coChat_list")
  //   .then((response) => response)
  //   .catch((error) => error);
});

export const getCoChatChannelsDetails = createAsyncThunk("getCoChatChannelsDetails", async (channelId: any) => {
  // return CoreServices.get(`/get_coChat_list_id/${channelId}`)
  //   .then((response) => response)
  //   .catch((error) => error);
});

export const getCoChatUserInteractionsDetails = createAsyncThunk("getCoChatUserInteractionsDetails", async (number: any) => {
  // return CallServices.post(number, "/get_chatByNumber")
  //   .then((response) => response)
  //   .catch((error) => error);
});
